var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 114,
    viewBox: "0 0 111 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.21 10.2812H5.34497V110.682H101.21V10.2812Z",
    fill: "#EDEDED",
    stroke: "#878787",
    strokeWidth: 0.9958,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.21 10.2812H5.34497V81.8235H101.21V10.2812Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 13.8258C106.032 13.8258 106.316 13.5556 106.316 13.2224C106.316 12.8892 106.032 12.6191 105.681 12.6191C105.331 12.6191 105.046 12.8892 105.046 13.2224C105.046 13.5556 105.331 13.8258 105.681 13.8258Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 16.2642C106.032 16.2642 106.316 15.9941 106.316 15.6609C106.316 15.3277 106.032 15.0576 105.681 15.0576C105.331 15.0576 105.046 15.3277 105.046 15.6609C105.046 15.9941 105.331 16.2642 105.681 16.2642Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 18.7025C106.032 18.7025 106.316 18.4324 106.316 18.0992C106.316 17.766 106.032 17.4958 105.681 17.4958C105.331 17.4958 105.046 17.766 105.046 18.0992C105.046 18.4324 105.331 18.7025 105.681 18.7025Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 21.1158C106.032 21.1158 106.316 20.8457 106.316 20.5125C106.316 20.1793 106.032 19.9092 105.681 19.9092C105.331 19.9092 105.046 20.1793 105.046 20.5125C105.046 20.8457 105.331 21.1158 105.681 21.1158Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 23.554C106.032 23.554 106.316 23.2839 106.316 22.9507C106.316 22.6175 106.032 22.3474 105.681 22.3474C105.331 22.3474 105.046 22.6175 105.046 22.9507C105.046 23.2839 105.331 23.554 105.681 23.554Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 25.9674C106.032 25.9674 106.316 25.6972 106.316 25.364C106.316 25.0309 106.032 24.7607 105.681 24.7607C105.331 24.7607 105.046 25.0309 105.046 25.364C105.046 25.6972 105.331 25.9674 105.681 25.9674Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 28.4058C106.032 28.4058 106.316 28.1357 106.316 27.8025C106.316 27.4693 106.032 27.1992 105.681 27.1992C105.331 27.1992 105.046 27.4693 105.046 27.8025C105.046 28.1357 105.331 28.4058 105.681 28.4058Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 30.8441C106.032 30.8441 106.316 30.574 106.316 30.2408C106.316 29.9076 106.032 29.6375 105.681 29.6375C105.331 29.6375 105.046 29.9076 105.046 30.2408C105.046 30.574 105.331 30.8441 105.681 30.8441Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 33.2574C106.032 33.2574 106.316 32.9873 106.316 32.6541C106.316 32.3209 106.032 32.0508 105.681 32.0508C105.331 32.0508 105.046 32.3209 105.046 32.6541C105.046 32.9873 105.331 33.2574 105.681 33.2574Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 35.6956C106.032 35.6956 106.316 35.4255 106.316 35.0923C106.316 34.7591 106.032 34.489 105.681 34.489C105.331 34.489 105.046 34.7591 105.046 35.0923C105.046 35.4255 105.331 35.6956 105.681 35.6956Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 38.109C106.032 38.109 106.316 37.8389 106.316 37.5057C106.316 37.1725 106.032 36.9023 105.681 36.9023C105.331 36.9023 105.046 37.1725 105.046 37.5057C105.046 37.8389 105.331 38.109 105.681 38.109Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 40.5472C106.032 40.5472 106.316 40.2771 106.316 39.9439C106.316 39.6107 106.032 39.3406 105.681 39.3406C105.331 39.3406 105.046 39.6107 105.046 39.9439C105.046 40.2771 105.331 40.5472 105.681 40.5472Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 42.9605C106.032 42.9605 106.316 42.6904 106.316 42.3572C106.316 42.024 106.032 41.7539 105.681 41.7539C105.331 41.7539 105.046 42.024 105.046 42.3572C105.046 42.6904 105.331 42.9605 105.681 42.9605Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 45.399C106.032 45.399 106.316 45.1289 106.316 44.7957C106.316 44.4625 106.032 44.1924 105.681 44.1924C105.331 44.1924 105.046 44.4625 105.046 44.7957C105.046 45.1289 105.331 45.399 105.681 45.399Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 47.8372C106.032 47.8372 106.316 47.5671 106.316 47.2339C106.316 46.9007 106.032 46.6306 105.681 46.6306C105.331 46.6306 105.046 46.9007 105.046 47.2339C105.046 47.5671 105.331 47.8372 105.681 47.8372Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 50.2506C106.032 50.2506 106.316 49.9805 106.316 49.6473C106.316 49.3141 106.032 49.0439 105.681 49.0439C105.331 49.0439 105.046 49.3141 105.046 49.6473C105.046 49.9805 105.331 50.2506 105.681 50.2506Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 52.6888C106.032 52.6888 106.316 52.4187 106.316 52.0855C106.316 51.7523 106.032 51.4822 105.681 51.4822C105.331 51.4822 105.046 51.7523 105.046 52.0855C105.046 52.4187 105.331 52.6888 105.681 52.6888Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 55.1021C106.032 55.1021 106.316 54.832 106.316 54.4988C106.316 54.1656 106.032 53.8955 105.681 53.8955C105.331 53.8955 105.046 54.1656 105.046 54.4988C105.046 54.832 105.331 55.1021 105.681 55.1021Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 57.5404C106.032 57.5404 106.316 57.2702 106.316 56.937C106.316 56.6038 106.032 56.3337 105.681 56.3337C105.331 56.3337 105.046 56.6038 105.046 56.937C105.046 57.2702 105.331 57.5404 105.681 57.5404Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 59.9537C106.032 59.9537 106.316 59.6836 106.316 59.3504C106.316 59.0172 106.032 58.7471 105.681 58.7471C105.331 58.7471 105.046 59.0172 105.046 59.3504C105.046 59.6836 105.331 59.9537 105.681 59.9537Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 62.3922C106.032 62.3922 106.316 62.1221 106.316 61.7889C106.316 61.4557 106.032 61.1855 105.681 61.1855C105.331 61.1855 105.046 61.4557 105.046 61.7889C105.046 62.1221 105.331 62.3922 105.681 62.3922Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 64.8304C106.032 64.8304 106.316 64.5603 106.316 64.2271C106.316 63.8939 106.032 63.6238 105.681 63.6238C105.331 63.6238 105.046 63.8939 105.046 64.2271C105.046 64.5603 105.331 64.8304 105.681 64.8304Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 67.2437C106.032 67.2437 106.316 66.9736 106.316 66.6404C106.316 66.3072 106.032 66.0371 105.681 66.0371C105.331 66.0371 105.046 66.3072 105.046 66.6404C105.046 66.9736 105.331 67.2437 105.681 67.2437Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 69.682C106.032 69.682 106.316 69.4118 106.316 69.0786C106.316 68.7455 106.032 68.4753 105.681 68.4753C105.331 68.4753 105.046 68.7455 105.046 69.0786C105.046 69.4118 105.331 69.682 105.681 69.682Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 72.0953C106.032 72.0953 106.316 71.8252 106.316 71.492C106.316 71.1588 106.032 70.8887 105.681 70.8887C105.331 70.8887 105.046 71.1588 105.046 71.492C105.046 71.8252 105.331 72.0953 105.681 72.0953Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 74.5335C106.032 74.5335 106.316 74.2634 106.316 73.9302C106.316 73.597 106.032 73.3269 105.681 73.3269C105.331 73.3269 105.046 73.597 105.046 73.9302C105.046 74.2634 105.331 74.5335 105.681 74.5335Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 76.9469C106.032 76.9469 106.316 76.6767 106.316 76.3435C106.316 76.0103 106.032 75.7402 105.681 75.7402C105.331 75.7402 105.046 76.0103 105.046 76.3435C105.046 76.6767 105.331 76.9469 105.681 76.9469Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 79.3853C106.032 79.3853 106.316 79.1152 106.316 78.782C106.316 78.4488 106.032 78.1787 105.681 78.1787C105.331 78.1787 105.046 78.4488 105.046 78.782C105.046 79.1152 105.331 79.3853 105.681 79.3853Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 81.8236C106.032 81.8236 106.316 81.5535 106.316 81.2203C106.316 80.8871 106.032 80.6169 105.681 80.6169C105.331 80.6169 105.046 80.8871 105.046 81.2203C105.046 81.5535 105.331 81.8236 105.681 81.8236Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 84.2369C106.032 84.2369 106.316 83.9668 106.316 83.6336C106.316 83.3004 106.032 83.0303 105.681 83.0303C105.331 83.0303 105.046 83.3004 105.046 83.6336C105.046 83.9668 105.331 84.2369 105.681 84.2369Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 86.6751C106.032 86.6751 106.316 86.405 106.316 86.0718C106.316 85.7386 106.032 85.4685 105.681 85.4685C105.331 85.4685 105.046 85.7386 105.046 86.0718C105.046 86.405 105.331 86.6751 105.681 86.6751Z",
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.682 96.8058C104.994 96.8058 104.464 96.2779 104.464 95.6495V89.2393C104.464 88.5858 105.02 88.083 105.682 88.083C106.369 88.083 106.899 88.6109 106.899 89.2393V95.6495C106.925 96.2779 106.369 96.8058 105.682 96.8058Z",
    fill: "white",
    stroke: "#878787",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.216 10.2814H3.57207C2.32844 7.59162 2.19614 4.87673 3.57207 2.11157H107.216C108.857 4.85159 108.857 7.56648 107.216 10.2814Z",
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightImg);
export default __webpack_public_path__ + "static/media/right_img.392e696c1cb311777d6d45cedebd968e.svg";
export { ForwardRef as ReactComponent };